import { Component, EventEmitter, Input, Output } from '@angular/core';
import { environment } from '@environments/environment';
import { AuthService } from '@auth0/auth0-angular';
import { BrowserStorageHelper } from '@core/helpers';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-menu-profile[closePopover][isSwitchGroupDisplayed][switchGroupDisplayChange]',
    templateUrl: './menu-profile.component.html',
    styleUrls: ['./menu-profile.component.scss'],
    standalone: true,
    imports: [CommonModule, TranslateModule],
})
export class MenuProfileComponent {
    @Input() isSwitchGroupDisplayed: boolean = false;
    @Output() closePopover: EventEmitter<void> = new EventEmitter<void>();
    @Output() switchGroupDisplayChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    readonly accountSettingsUrl = environment.accountSettingsUrl;
    readonly quickorderSettingsUrl = environment.quickorderSettingsUrl;
    readonly billingSettingsUrl = environment.billingSettingsUrl;
    readonly messageSettingsUrl = environment.messageSettingsUrl;

    constructor(private auth0: AuthService) {}

    close(): void {
        this.switchGroupDisplayChange.emit(false);
        this.closePopover.emit();
    }

    async logout(): Promise<void> {
        const url = `${environment.auth0.logoutUrl}?client_id=${environment.auth0.clientId}&returnTo=${encodeURI(
            environment.auth0.logoutReturnUrl
        )}`;
        BrowserStorageHelper.killSession();

        await this.auth0.logout({
            openUrl(_url) {
                window.location.replace(url);
            },
        });
    }
}
